import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { Component, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { InvoicePDFComponent } from '@components/pdf/invoice-pdf/invoice-pdf.component';
import { InvoiceDto } from '@dto/invoiceDto';
import { TransactionDto } from '@dto/transactionDto';
import { UserDto } from '@dto/userDto';
import { InvoicePDFType } from '@enums/invoicePDFType.enum';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { InvoicesService } from '@services/entity/invoices.service';
import { TransactionsService } from '@services/entity/transactions.service';
import { UsersService } from '@services/entity/users.service';
import { ToastService } from '@services/toast/toast.service';
import { plainToClass } from 'class-transformer';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-print-invoice-dialog-content',
  templateUrl: './print-invoice-dialog-content.component.html',
  styleUrls: ['./print-invoice-dialog-content.component.scss']
})
export class PrintInvoiceDialogContentComponent extends AbstractDialogContent implements OnInit {

  public className = 'PrintInvoiceDialogContentComponent';

  public invoice: InvoiceDto;

  public filename: string
  public filenameFirstVariable: string = 'invoiceNumber'
  public filenameSecondVariable: string
  public filenameThirdVariable: string

  public user: UserDto;
  public isUser: boolean = false
  public isCustomer: boolean = false
  public isOperator: boolean = false

  @Input() public invoiceId: number;

  constructor(
    public activeModal: NgbActiveModal,
    public dialog: NgbModal,
    private invoicesService: InvoicesService,
    private spinner: NgxSpinnerService,
    public usersService: UsersService,
    public toastService: ToastService,
    injector: Injector) {
    super(activeModal, injector);
  }

  async ngOnInit() {
    this.getRoles()

    if (this.isCustomer || this.isOperator) {
      this.getInvoice()
    } else if (this.isUser) {
      this.getInvoiceOfCurrentUser()
    }

    super.ngOnInit()
  }

  getInvoice() {
    this.invoicesService.getInvoice(this.invoiceId).subscribe(result => {
      this.invoice = plainToClass(InvoiceDto, result)
      this.getFilename()
      this.setFilename()
    }, error => {
      console.error(error)
    })
  }

  getInvoiceOfCurrentUser() {
    this.invoicesService.getInvoiceOfCurrentUser(this.invoiceId).subscribe(invoice => {
      this.invoice = plainToClass(InvoiceDto, invoice)
      this.getFilename()
      this.setFilename()
    }, error => console.error(error))
  }

  toggleFilenameVariable(variable, value) {
    if (this[variable] != '') this[variable] = value
    else this[variable] = ''
    this.setFilename()
  }

  setFilename() {
    let firstVariable = this.invoice[this.filenameFirstVariable]
    this.filename = this.isDate(firstVariable) ? this.parseDate(firstVariable) : firstVariable.replace(/ /g, '_')

    if (this.filenameSecondVariable && this.filenameSecondVariable != "undefined") {
      let variable = this.invoice[this.filenameSecondVariable]
      if (this.isDate(variable)) variable = this.parseDate(variable)
      this.filename += `_${variable.replace(/ /g, '_')}`
    }

    if (this.filenameThirdVariable && this.filenameThirdVariable != "undefined") {
      let variable = this.invoice[this.filenameThirdVariable]
      if (this.isDate(variable)) variable = this.parseDate(variable)
      this.filename += `_${variable.replace(/ /g, '_')}`
    }

    this.filename += '.pdf'

    localStorage.setItem('invoiceFilenameFirstVariable', this.filenameFirstVariable)
    
    if (this.filenameSecondVariable != null)
      localStorage.setItem('invoiceFilenameSecondVariable', this.filenameSecondVariable)
    if (this.filenameThirdVariable != null)
      localStorage.setItem('invoiceFilenameThirdVariable', this.filenameThirdVariable)
  }

  getFilename() {
    if (localStorage.getItem('invoiceFilenameFirstVariable'))
      this.filenameFirstVariable = localStorage.getItem('invoiceFilenameFirstVariable')
    if (localStorage.getItem('invoiceFilenameSecondVariable') != null)
      this.filenameSecondVariable = localStorage.getItem('invoiceFilenameSecondVariable')
    if (localStorage.getItem('invoiceFilenameThirdVariable') != null)
      this.filenameThirdVariable = localStorage.getItem('invoiceFilenameThirdVariable')
  }

  isDate(value: string) {
    if (!value || typeof value != 'string') return false
    return new RegExp(/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z*/).test(value.trim())
  }

  parseDate(date: Date) {
    date = new Date(date)
    const y = date.getFullYear()
    const m = date.getMonth()
    const d = date.getDate()
    return `${y}-${m < 10 ? '0' + m : m}-${d < 10 ? '0' + d : d}`
  }

  async downloadAsPDF() {
    this.toastService.loading("PDF wird erstellt, bitte warten...", true);
    this.invoicesService.getInvoicePdf(this.invoiceId).subscribe((response: any) => {
      const file = new Blob([response], { type: 'application/pdf' });
      const fileUrl = URL.createObjectURL(file);

      var a = document.createElement('a');
      document.body.appendChild(a);
      a.style.display = 'none';
      a.href = fileUrl;
      a.download = this.filename;
      a.click();
      this.toastService.clear();

      window.URL.revokeObjectURL(fileUrl);
    },
    error => {
      console.error(error);
      this.toastService.error(`Rechnung konnte nicht heruntergeladen werden.`)
      })

    this.close();
  }

  async sendPerEmail() {
    const dialogRef = this.dialog.open(InvoicePDFComponent, { centered: true, size: 'md', backdrop: 'static' });
    dialogRef.componentInstance.type = InvoicePDFType.Email;
    dialogRef.componentInstance.invoice = this.invoice;
    dialogRef.componentInstance.filename = this.filename;

    // Todo
  }

  getRoles() {
    if (this.authenticationService.userHasRole('Operator')) this.isOperator = true;
    if (this.authenticationService.userHasRole('Customer')) this.isCustomer = true;
    if (this.authenticationService.userHasRole('User')) this.isUser = true;
  }

  close() {
    this.activeModal.close();
  }
}
